import React, { useEffect, useState } from "react";
import {
  server_post_data,
  maintainance_car_data,
} from "../../ServiceConnection/serviceconnection";
import { handleError } from "../../CommonJquery/CommonJquery";

const LightCheck = ({
  onNext,
  onBack,
  MaintainanceData,
  setCount,
  ImageLink,
  BookingData,
  cardata,
  FromComeData,
}) => {
  const [showLoaderAdmin, setshowLoaderAdmin] = useState(false);
  const [lightCheckData, setLightCheckData] = useState({
    tailLights: {
      right: "",
      left: "",
      reverseRight: "",
      reverseLeft: "",
      blinkerRight: "",
      blinkerLeft: "",
    },
    frontLights: {
      rightLow: "",
      leftHigh: "",
      rightHigh: "",
      leftLow: "",
      blinkerRight: "",
      blinkerLeft: "",
    },
  });

  const [notesData, setNotesData] = useState({
    tailLights: {
      right: "",
      left: "",
      reverseRight: "",
      reverseLeft: "",
      blinkerRight: "",
      blinkerLeft: "",
    },
    frontLights: {
      rightLow: "",
      leftHigh: "",
      rightHigh: "",
      leftLow: "",
      blinkerRight: "",
      blinkerLeft: "",
    },
  });

  useEffect(() => {
    setLightCheckData({
      tailLights: {
        right: MaintainanceData.tail_right || "",
        left: MaintainanceData.tail_left || "",
        reverseRight: MaintainanceData.tail_reverse_right || "",
        reverseLeft: MaintainanceData.tail_reverse_left || "",
        blinkerRight: MaintainanceData.tail_binker_right || "",
        blinkerLeft: MaintainanceData.tail_binker_left || "",
      },
      frontLights: {
        rightLow: MaintainanceData.front_light_right_low || "",
        leftHigh: MaintainanceData.front_light_left_high || "",
        rightHigh: MaintainanceData.front_light_right_high || "",
        leftLow: MaintainanceData.front_light_left_low || "",
        blinkerRight: MaintainanceData.blinker_right || "",
        blinkerLeft: MaintainanceData.blinker_left || "",
      },
    });

    // Initialize notes if they exist in MaintainanceData
    setNotesData({
      tailLights: {
        right: MaintainanceData.tail_right_note || "",
        left: MaintainanceData.tail_left_note || "",
        reverseRight: MaintainanceData.tail_reverse_right_note || "",
        reverseLeft: MaintainanceData.tail_reverse_left_note || "",
        blinkerRight: MaintainanceData.tail_binker_right_note || "",
        blinkerLeft: MaintainanceData.tail_binker_left_note || "",
      },
      frontLights: {
        rightLow: MaintainanceData.front_light_right_low_note || "",
        leftHigh: MaintainanceData.front_light_left_high_note || "",
        rightHigh: MaintainanceData.front_light_right_high_note || "",
        leftLow: MaintainanceData.front_light_left_low_note || "",
        blinkerRight: MaintainanceData.blinker_right_note || "",
        blinkerLeft: MaintainanceData.blinker_left_note || "",
      },
    });
  }, [MaintainanceData]);

  const [errors, setErrors] = useState({
    tailLights: {},
    frontLights: {},
  });

  // Handle light status change
  const handleLightChange = (section, position, status) => {
    setLightCheckData((prev) => ({
      ...prev,
      [section]: {
        ...prev[section],
        [position]: status,
      },
    }));

    // Clear notes if status is not "Need Repair"
    if (status !== "Need Repair") {
      setNotesData((prev) => ({
        ...prev,
        [section]: {
          ...prev[section],
          [position]: "",
        },
      }));
    }

    // Clear errors
    setErrors((prev) => ({
      ...prev,
      [section]: {
        ...prev[section],
        [position]: false,
        [`${position}_note`]: false,
      },
    }));
  };

  // Handle notes change
  const handleNotesChange = (section, position, value) => {
    setNotesData((prev) => ({
      ...prev,
      [section]: {
        ...prev[section],
        [position]: value,
      },
    }));

    // Clear note error
    setErrors((prev) => ({
      ...prev,
      [section]: {
        ...prev[section],
        [`${position}_note`]: false,
      },
    }));
  };

  const validateForm = () => {
    const newErrors = { tailLights: {}, frontLights: {} };
    let isValid = true;
    let tailLightErrors = [];
    let frontLightErrors = [];

    // Validate tail lights
    Object.entries(lightCheckData.tailLights).forEach(([key, value]) => {
      if (!value) {
        tailLightErrors.push(key.replace(/([A-Z])/g, " $1").toLowerCase());
        newErrors.tailLights[key] = true;
        isValid = false;
      }

      // Validate notes if "Need Repair" is selected
      if (value === "Need Repair" && !notesData.tailLights[key]?.trim()) {
        newErrors.tailLights[`${key}_note`] = true;
        isValid = false;
      }
    });

    // Validate front lights
    Object.entries(lightCheckData.frontLights).forEach(([key, value]) => {
      if (!value) {
        frontLightErrors.push(key.replace(/([A-Z])/g, " $1").toLowerCase());
        newErrors.frontLights[key] = true;
        isValid = false;
      }

      // Validate notes if "Need Repair" is selected
      if (value === "Need Repair" && !notesData.frontLights[key]?.trim()) {
        newErrors.frontLights[`${key}_note`] = true;
        isValid = false;
      }
    });

    if (tailLightErrors.length > 0) {
      newErrors.tailLights.general = `Please fill: ${tailLightErrors.join(
        ", "
      )}`;
    }

    if (frontLightErrors.length > 0) {
      newErrors.frontLights.general = `Please fill: ${frontLightErrors.join(
        ", "
      )}`;
    }

    setErrors(newErrors);
    return isValid;
  };
  const handleNext = async () => {
    if (validateForm()) {
      setshowLoaderAdmin(true);
      const fd = new FormData();

      // Append base data
      fd.append("car_id", cardata.primary_id);
      fd.append("booking_id", cardata.current_booking_id);
      fd.append("user_id", BookingData?.user_id || 0);
      fd.append("step_for_maintenance", 1);
      fd.append("edit_or_new", MaintainanceData?.primary_id || 0);
      fd.append("save_or_edit_type", FromComeData);

      // Tail lights
      Object.entries(lightCheckData.tailLights).forEach(([key, value]) => {
        const fieldName =
          key === "right"
            ? "tail_right"
            : key === "left"
            ? "tail_left"
            : key === "reverseRight"
            ? "tail_reverse_right"
            : key === "reverseLeft"
            ? "tail_reverse_left"
            : key === "blinkerRight"
            ? "tail_binker_right"
            : "tail_binker_left";

        let finalValue = value;

        // If Need Repair and note exists, use the note instead of status
        if (value === "Need Repair" && notesData.tailLights[key]) {
          finalValue = notesData.tailLights[key];
        }

        fd.append(fieldName, finalValue);
        // console.log(`TAIL ${fieldName}: ${finalValue}`);
      });

      // Front lights
      Object.entries(lightCheckData.frontLights).forEach(([key, value]) => {
        const fieldName =
          key === "rightLow"
            ? "front_light_right_low"
            : key === "leftLow"
            ? "front_light_left_low"
            : key === "rightHigh"
            ? "front_light_right_high"
            : key === "leftHigh"
            ? "front_light_left_high"
            : key === "blinkerRight"
            ? "blinker_right"
            : "blinker_left";

        let finalValue = value;

        // If Need Repair and note exists, use the note instead of status
        if (value === "Need Repair" && notesData.frontLights[key]) {
          finalValue = notesData.frontLights[key];
        }

        fd.append(fieldName, finalValue);
        // console.log(`FRONT ${fieldName}: ${finalValue}`);
      });

      // Submit to server
      try {
        const response = await server_post_data(maintainance_car_data, fd);
        if (response.data.error) {
          handleError(response.data.message);
        } else {
          //console.log("Server response:", response.data.message);
          onNext();
          setCount(2);
        }
      } catch (error) {
        handleError("network");
      } finally {
        setshowLoaderAdmin(false);
      }
    }
  };

  // Light configuration for rendering
  const lightConfigs = {
    tailLights: [
      { key: "right", label: "Right" },
      { key: "left", label: "Left" },
      { key: "reverseRight", label: "Reverse Right" },
      { key: "reverseLeft", label: "Reverse Left" },
      { key: "blinkerRight", label: "Blinker Right" },
      { key: "blinkerLeft", label: "Blinker Left" },
    ],
    frontLights: [
      { key: "rightLow", label: "Right Low" },
      { key: "rightHigh", label: "Right High" },
      { key: "leftHigh", label: "Left High" },
      { key: "leftLow", label: "Left Low" },
      { key: "blinkerRight", label: "Blinker Right" },
      { key: "blinkerLeft", label: "Blinker Left" },
    ],
  };

  // Render light section component
  const renderLightSection = (section, config) => {
    const data = lightCheckData[section];
    const sectionErrors = errors[section];
    return config.map(({ key, label }) => (
      <div key={key} className="light-section mt-2">
        <div className="light_left_right_containr">
          <div className="tail_light_left_section">
            <label className="position-label">
              {label}
              {sectionErrors?.[key] && (
                <span className="error-indicator"> *</span>
              )}
            </label>
          </div>

          <div className="tail_light_right_section">
            {["Good", "Replaced", "Need Repair"].map((status) => {
              const currentValue = data[key];
              const isEmpty = !currentValue;
              const isOther =
                currentValue &&
                currentValue !== "Good" &&
                currentValue !== "Replaced";
              const isActive =
                (!isEmpty && currentValue === status) ||
                (isOther && status === "Need Repair");

              return (
                <div key={status} className="col-md-4">
                  <div className="btn-group" role="group">
                    <button
                      type="button"
                      className={`btn btn-outline-secondary ${
                        isActive
                          ? `active ${
                              status === "Good"
                                ? "goodActive"
                                : status === "Replaced"
                                ? "needBulbActive"
                                : "needRepairActive"
                            }`
                          : ""
                      }`}
                      onClick={() => handleLightChange(section, key, status)}
                    >
                      {status}
                    </button>
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        {/* Show notes section only when "Need Repair" is selected */}
        {data[key] == "Need Repair" && (
          <div className="note_div">
            <label className="position-label">
              Note *
              {sectionErrors?.[`${key}_note`] && (
                <span className="error-text"> (Required)</span>
              )}
            </label>
            <textarea
              className={`form-control ${
                sectionErrors?.[`${key}_note`] ? "error-border" : ""
              }`}
              rows="3"
              placeholder="Enter repair notes here..."
              maxLength={500}
              defaultValue={data[key] || ""}
              onChange={(e) => handleNotesChange(section, key, e.target.value)}
            />
          </div>
        )}
      </div>
    ));
  };

  return (
    <>
      <div className="light-check-container">
        {/* Tail Lights Section */}
        <h3 className="section-title text-primary">
          Tail Lights <span className="mandory_field">*</span>
        </h3>
        {Object.keys(errors.tailLights).map((key) => {
          if (
            errors.tailLights[key] &&
            typeof errors.tailLights[key] === "string"
          ) {
            return (
              <span key={key} className="error-text">
                {errors.tailLights[key]}
              </span>
            );
          }
          return null;
        })}

        {renderLightSection("tailLights", lightConfigs.tailLights)}

        {/* Front Lights Section */}
        <h3 className="section-title text-primary mt-4">
          Front Lights <span className="mandory_field">*</span>
        </h3>
        {Object.keys(errors.frontLights).map((key) => {
          if (
            errors.frontLights[key] &&
            typeof errors.frontLights[key] === "string"
          ) {
            return (
              <span key={key} className="error-text">
                {errors.frontLights[key]}
              </span>
            );
          }
          return null;
        })}

        {renderLightSection("frontLights", lightConfigs.frontLights)}
      </div>

      <div className="navigation-buttons">
        <button className="btn back-button" onClick={onBack}>
          Back
        </button>
        <button
          className="btn next__button"
          onClick={handleNext}
          disabled={showLoaderAdmin}
        >
          Next
        </button>
      </div>
    </>
  );
};

export default LightCheck;
